import PropTypes from 'prop-types';
import TituloSessao from '../componentes/TituloSessao';
import { useNavigate } from 'react-router-dom';

function TelaInformativa({ cabecalho, mensagem, pathRedirect, buttonMessage, urlExterna }) {

    const navigate = useNavigate();
    console.log(pathRedirect)

    function voltar() {
        if (urlExterna) {
            window.location.href = `${pathRedirect}`;
        } else {
            // Se passado o pathRedirect, entende se que deve usar o navigate
            if (pathRedirect) {
                navigate(pathRedirect);
            } else {
                // Se nenhum path for passado, um simples reload ja volta pra tela anterior
                window.location.reload();
            }
        }
    }

    return (
        <div className='pagina-tamanho-minimo container-fluid'>
            <TituloSessao titulo={cabecalho} barraDecorativa={false} />
            <div className='d-flex flex-column align-items-center'>
                <p>{mensagem}</p>
                <button className='btn btn-primary' onClick={voltar}>{buttonMessage}</button>
            </div>
        </div>
    );
}

TelaInformativa.propTypes = {
    cabecalho: PropTypes.string.isRequired,
    mensagem: PropTypes.string.isRequired,
    buttonMessage: PropTypes.string.isRequired,
    urlExterna: PropTypes.bool.isRequired
};

export default TelaInformativa

// pathRedirect: PropTypes.string.isRequired,